import React, { useRef } from "react";
import ErrorHandler from "@components/error-boundaries/ErrorHandler";

interface ICardContent {
    fileExt: string;
    fileSrc: string;
    fileMime: string;
    isExpandedView?: boolean;
}

const AssetCardContent: React.FC<ICardContent> = ({
    fileExt,
    fileMime,
    fileSrc,
    isExpandedView,
}) => {
    const videoRef = useRef(null);
    // Sentry play() and pause() error
    // https://developer.chrome.com/blog/play-request-was-interrupted/
    const playOrPauseHandler = (event: React.MouseEvent<HTMLVideoElement>) => {
        if (videoRef.current) {
            videoRef.current = false;
            !isExpandedView && (event.target as HTMLVideoElement).pause();
        } else {
            !isExpandedView &&
                (event.target as HTMLVideoElement).play().then(() => {
                    videoRef.current = true;
                });
        }
    };

    return (
        <>
            <ErrorHandler>
                {fileExt === "mp4" || fileExt === "mov" ? (
                    <video
                        ref={videoRef}
                        id="video"
                        src={`${fileSrc}`}
                        // @ts-ignore
                        type={fileMime}
                        onMouseOver={(
                            event: React.MouseEvent<HTMLVideoElement>
                        ) => playOrPauseHandler(event)}
                        onMouseOut={(
                            event: React.MouseEvent<HTMLVideoElement>
                        ) => playOrPauseHandler(event)}
                        style={
                            isExpandedView
                                ? { width: "100%", height: "100%" }
                                : {objectFit: "cover", height: "10rem" }
                        }
                        controls={isExpandedView}
                        loop
                        muted
                    ></video>
                ) : (
                    <img
                        className="img-fluid mx-auto"
                        src={fileSrc}
                        alt=""
                        style={
                            isExpandedView
                                ? { width: "100%", height: "100%" }
                                : { width: "18rem", height: "10rem" }
                        }
                    />
                )}
            </ErrorHandler>
        </>
    );
};

export default AssetCardContent;
